import React from 'react'
import { Table, Icon } from 'rsuite'

const { Column, HeaderCell, Cell } = Table

export default function COIValidateTableWidget({ tableData = [], ...props }) {
  return (
    <Table
      wordWrap
      // height={tableData?.length > 0 ? 400 : 60}
      height={tableData?.length > 2 ? 400 : 200}
      data={tableData}
      autoHeight={tableData?.length <= 5}
      style={{ marginBottom: 10 }}
    >
      <Column minWidth={60} align="center">
        <HeaderCell>
          <span>ลำดับที่</span>
        </HeaderCell>
        <Cell>
          {(rowData, index) => {
            return `${index + 1}`
          }}
        </Cell>
      </Column>
      <Column width={450} flexGrow={3}>
        <HeaderCell>
          <span>สาเหตุ</span>
        </HeaderCell>
        <Cell dataKey="cause" />
      </Column>
      <Column width={120} flexGrow={1}>
        <HeaderCell>
          <span>หมายเหตุ</span>
        </HeaderCell>
        <Cell>
          {(rowData, index) => {
            return (
              <>
                <Icon
                  size="lg"
                  style={{ color: !rowData.result ? '#21a383' : '#eb3626' }}
                  icon={!rowData.result ? 'check-circle' : 'close-circle'}
                />
              </>
            )
          }}
        </Cell>
      </Column>
    </Table>
  )
}
